<template>
  <Layout v-if="aupair">
    <ChiWarning
      type="info"
      title="Show Interest"
      text="
          Thank you for showing interest in one of our Au Pairs. You will be contacted by a customer care specialist soon after your submission. In the meantime, <a target='_blank' href='/agreement'><strong>you can review our program agreement here</strong></a>."
    />

    <ChiCard title="Show interest in Au Pair" class="text-center">
      <div class="-mx-12 px-12 flex flex-col items-center justify-center">
        <AuPairName :name="aupair.firstName" class="mb-5" />
        <Photo
          :src="aupair.profilePhoto"
          :alt="aupair.firstName"
          class="mb-5"
        />
        <ChildCareHours :aupair="aupair" class="mb-5" />
        <div class="w-full border-b border-purple-ap-t03 pb-5 mb-5">
          <Nationality :birthCountry="aupair.birthCountry" />
          <Age :age="aupair.birthDate" />
          <InfantCareQualified
            :infantCareQualified="aupair.infantCareQualified"
          />
          <Driver :experiencedDriver="aupair.experiencedDriver" />
          <Swimmer :swimmer="aupair.swimmer" />
        </div>
      </div>
      <div
        v-if="!processing"
        class="w-full flex flex-col lg:flex-row p-5 justify-around items-center"
      >
        <button
          @click.prevent="confirmMatchRequest(aupair.auPairPromoProfileId)"
          class="btn text-white bg-green-600 mb-10 lg:mb-0"
        >
          Show interest in Au Pair
        </button>
        <button @click.prevent="giveUp()" class="btn">
          No, return to list
        </button>
      </div>
      <ComponentLoading v-else />
    </ChiCard>
  </Layout>
</template>

<script>
import { api } from "@/services.js";
import Layout from "@/Layout/Authenticated/Layout.vue";

import ChiWarning from "@/components/UI/ChiWarning.vue";
import ChiCard from "@/components/UI/ChiCard.vue";
import AuPairName from "@/components/AuPairs/AuPairCardItems/AuPairName.vue";
import ChildCareHours from "@/components/AuPairs/AuPairCardItems/ChildCareHours.vue";
import Nationality from "@/components/AuPairs/AuPairCardItems/Nationality.vue";
import Age from "@/components/AuPairs/AuPairCardItems/Age.vue";
import InfantCareQualified from "@/components/AuPairs/AuPairCardItems/InfantCareQualified.vue";
import Driver from "@/components/AuPairs/AuPairCardItems/Driver.vue";
import Swimmer from "@/components/AuPairs/AuPairCardItems/Swimmer.vue";
import Photo from "@/components/AuPairs/AuPairCardItems/Photo.vue";
export default {
  name: "MatchConfirmation",
  props: ["aupair"],
  components: {
    ChiCard,
    ChiWarning,
    Layout,
    AuPairName,
    ChildCareHours,
    Nationality,
    Age,
    InfantCareQualified,
    Driver,
    Swimmer,
    Photo,
  },
  data() {
    return {
      processing: false,
    };
  },
  created() {
    if (!this.aupair) {
      this.$router.push({ name: "RequestInterview" });
    }
  },
  methods: {
    giveUp() {
      this.$router.push({ name: "RequestInterview" });
    },
    confirmMatchRequest(id) {
      this.processing = true;
      api
        .post("/promotional/AuPairPromoProfiles/matchRequest", {
          auPairPromoProfileId: id,
        })
        .then(() => {
          this.processing = false;
          this.$toasted.global.notificate({
            message: "Your interest request was sent!",
            type: "success",
          });
          this.$store.commit("UPDATE_USER", { matchRequest: id });
          this.$router.push({
            name: "Matches",
          });
        })
        .catch((error) => {
          this.processing = false;
          this.$toasted.global.notificate({
            message: error.response.data.message,
            type: "error",
          });
        });
    },
  },
};
</script>

<style scoped>
.extra-info p {
  margin: 10px 0;
}

.extra-info p:last-child {
  margin-top: 20px;
}

.btn.confirmation {
  padding: 12px 30px;
  margin: 10px 0;
}
.btn-yes {
  background: #35ad45;
  color: #fff;
  font-weight: 700;
}

.btn-no {
  box-shadow: none;
}
</style>
